import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronLeftOutlinedSize12Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m3.375 6 3.75 3.75.742-.742L4.86 6l3.008-3.008-.743-.742z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ChevronLeftOutlinedSize12Glyph.displayName = 'ChevronLeftOutlinedSize12Glyph';
